// Tableaux de dimensions des tubes acier (DN, pouces, diamètre extérieur, épaisseur)
const tubesTables = {
  "tube-galvanise-soude": [
    {
      title: "Dimensions disponibles",
      notes: ["Norme de fabrication : ISO 65", "Galvanisation à chaud : EN 10240", "Livraison : bout fileté avec manchon"],
      header: [
        ["DN", "Diamètres (pouces)", "Diamètre extérieur (mm)", "Epaisseurs (mm)"]
      ],
      rows: [
        ["15", "1/2″", "21.3", "1.90"],
        ["20", "3/4″", "26.7", "1.90"],
        ["25", "1″", "33.7", "1.90"],
        ["32", "1″-1/4", "42.4", "1.90"],
        ["40", "1″-1/2", "48.3", "2.5"],
        ["50", "2″", "60.3", "2.5"],
        ["65", "2″-1/2", "76.1", "2.5"],
        ["80", "3″", "88.9", "2.9"],
        ["100", "4″", "114.3", "3.2"]
      ]
    }
  ],
  "tube-galvanise-sans-soudure": [
    {
      title: "Dimensions disponibles",
      notes: ["Galvanisation à chaud : NF EN 10240 niveau A.1", "Zinc électrolytique pur à 99,995 %, sans plomb"],
      header: [
        ["DN", "Diamètres (pouces)", "Diamètre extérieur (mm)", "Epaisseurs (mm)"]
      ],
      rows: [
        ["15", "1/2″", "21.3", "2.3"],
        ["20", "3/4″", "26.7", "2.3"],
        ["25", "1″", "33.7", "2.6"],
        ["32", "1″-1/4", "42.4", "2.6"],
        ["40", "1″-1/2", "48.3", "2.6"],
        ["50", "2″", "60.3", "2.9"],
        ["65", "2″-1/2", "76.1", "2.9"],
        ["80", "3″", "88.9", "3.2"],
        ["100", "4″", "114.3", "3.6"]
      ]
    }
  ],
  "tube-noir-sans-soudure": [
    {
      title: "Tarif 10 - tube lisse",
      notes: ["Norme : EN 10216-1", "Grade acier : P235 TR1", "Température : de -10°C à 300°C", "Pression d'épreuve : 70 bar"],
      header: [
        ["DN", "Diamètres (pouces)", "Diamètre extérieur (mm)", "Epaisseurs (mm)"]
      ],
      rows: [
        ["15", "1/2″", "21.3", "2.3"],
        ["20", "3/4″", "26.9", "2.3"],
        ["25", "1″", "33.7", "2.6"],
        ["32", "1″-1/4", "42.4", "2.6"],
        ["40", "1″-1/2", "48.3", "2.6"],
        ["50", "2″", "60.3", "2.9"],
        ["65", "2″-1/2", "76.1", "2.9"],
        ["80", "3″", "88.9", "3.2"],
        ["100", "4″", "114.3", "3.6"],
        ["125", "5″", "139.7", "4.0"],
        ["150", "6″", "168.3", "4.5"],
        ["200", "8″", "219.1", "6.3"],
        ["250", "10″", "273.0", "6.3"],
        ["300", "12″", "323.9", "8.4"],
        ["350", "14″", "355.6", "8.0"],
        ["400", "16″", "406.4", "8.8"],
        ["450", "18″", "457", "10.0"],
        ["500", "20″", "508", "11.0"],
        ["550", "22″", "610", "12.5"]
      ]
    },
    {
      title: "Tarif 3 - tube filetable",
      notes: ["Norme : EN 10255", "Grade acier : S195", "Température : de -10°C à 110°C", "Pression d'épreuve : 50 bar", "Pression nominale : PN25"],
      header: [
        ["DN", "Diamètres (pouces)", "Diamètre extérieur (mm)", "Epaisseurs (mm)"]
      ],
      rows: [
        ["15", "1/2″", "21.3", "2.6"],
        ["20", "3/4″", "26.7", "2.6"],
        ["25", "1″", "33.7", "3.2"],
        ["32", "1″-1/4", "42.4", "3.2"],
        ["40", "1″-1/2", "48.3", "3.2"],
        ["50", "2″", "60.3", "3.6"],
        ["65", "2″-1/2", "76.1", "3.6"],
        ["80", "3″", "88.9", "4.05"],
        ["100", "4″", "114.3", "4.5"]
      ]
    }
  ],
  "tube-chaudiere": [
    {
      title: "Dimensions disponibles",
      notes: ["Norme : EN 10216-2", "Grade acier : P235GH / St 35.8 I", "Température de service : jusqu'à 600°C", "Pression d'épreuve : 70 bar"],
      header: [
        ["DN", "Diamètres (pouces)", "Diamètre extérieur (mm)", "Epaisseurs (mm)"]
      ],
      rows: [
        ["40", "1″-1/2", "48.3", "2.9"],
        ["40", "1″-1/2", "48.3", "3.2"],
        ["50", "2″", "60.3", "2.9"],
        ["50", "2″", "60.3", "3.2"],
        ["65", "2″-1/2", "76.1", "3.6"]
      ]
    }
  ]
};

export default tubesTables;
